module.exports = new __parcel__URL__("music_button_active.ded1df97.png").toString();